export const chooseRadius = (value) => ({
  type: "CHOOSE_RADIUS",
  value
})

export const toggleShowProperties = () => ({
  type: "TOGGLE_SHOW_PROPERTIES"
})

export const toggleShowFill = () => ({
  type: "TOGGLE_SHOW_FILL"
})

export const changeParameter = (value) => ({
  type: "CHANGE_PARAMETER",
  value
})

export const updateStep = (slider, value) => ({
  type: "UPDATE_SLIDER_STEP",
  slider,
  value
})

export const togglePlotModal = (plot) => ({
  type: "TOGGLE_PLOT_MODAL",
  plot
})

export const resizePlotModal = (plot,width,height) => ({
  type: "RESIZE_PLOT_MODAL",
  width,
  height,
  plot
})

export const chooseHistogram = (x0, x1, radius) => ({
  type: "CHOOSE_HISTOGRAM",
  x0,
  x1,
  radius
})


// WEBPACK FOOTER //
// ./src/actions/stat.js